export default {
    InvoiceStatus: {
        All: 'All',
        Valid: 'Valid',
        Invalid: 'Invalid  ',
        WaitChecking: 'Checking',
        InvoiceDraft: 'Draft',
        NoHasPdf: 'No viewer',
        NoHasXml: 'No XML',
        Viewed: 'Viewed',
        UnViewed: 'Unviewed',
        Risky: 'Risk',
        NoRisky: 'No Risk',
        NotNeedCheck: 'Not checked'
    },
    OutInvoiceStatus: { All: 'All', HasXml: 'Has XML', NoHasXml: 'No XML' },
    Role: { Admin: 'Admin', User: 'User  ' },
    TypeOfMoney: { VND: 'VND', USD: 'USD' },
    Month: {
        Month1: 'January',
        Month2: 'February',
        Month3: 'March',
        Month4: 'April',
        Month5: 'May',
        Month6: 'June',
        Month7: 'July',
        Month8: 'August',
        Month9: 'September',
        Month10: 'October',
        Month11: 'November',
        Month12: 'December'
    },
    Quarter: {
        Quarter1: 'Quarter I',
        Quarter2: 'Quarter II',
        Quarter3: 'Quarter III',
        Quarter4: 'Quarter IV'
    },
    Period: {
        ThisDay: 'Today',
        ThisWeek: 'Current week',
        FirstWeekToPresent: 'Early week to present',
        ThisMonth: 'This month',
        Last30Days: 'Last 30 days',
        FirstMonthToPresent: 'Early month to present',
        ThisQuarter: 'This quarter',
        FirstQuarterToPresent: 'Early quater to present',
        ThisYear: 'This year',
        FirstYearToPresent: 'Early year to present',
        SixFirstMonth: 'First half of the year',
        SixLastMonth: 'Second half of the year',
        January: 'January',
        February: 'February',
        March: 'March',
        April: 'April',
        May: 'May',
        June: 'June',
        July: 'July',
        August: 'August',
        September: 'September',
        October: 'October',
        November: 'November',
        December: 'December',
        FiscalI: 'Quarter 1',
        FiscalII: 'Quarter 2',
        FiscalIII: 'Quarter 3',
        FiscalIV: 'Quarter 4',
        Yesterday: 'Yesterday',
        LastWeek: 'Last week',
        LastMonth: 'Last month',
        LastQuarter: 'Last quarter',
        LastYear: 'Last year',
        Tomorrow: 'Tomorrow',
        NextWeek: 'Next week',
        NextMonth: 'Next month',
        NextQuarter: 'Next quarter',
        NextYear: 'Next year',
        Custom: 'Optional',
        Last7Day: 'Last 7 days',
        Other: 'Optional'
    },
    PeriodMax30Days: {
        ThisDay: 'Today',
        ThisWeek: 'Current week',
        FirstWeekToPresent: 'Early week to present',
        ThisMonth: 'This month',
        Last30Days: 'Last 30 days',
        FirstMonthToPresent: 'Early month to present',
        January: 'January',
        February: 'February',
        March: 'March',
        April: 'April',
        May: 'May',
        June: 'June',
        July: 'July',
        August: 'August',
        September: 'September',
        October: 'October',
        November: 'November',
        December: 'December',
        Yesterday: 'Yesterday',
        LastWeek: 'Last week',
        LastMonth: 'Last month',
        Custom: 'Optional',
    },
    FormState: {
        View: 'View',
        Add: 'Add',
        Edit: 'Edit',
        Duplicate: 'Duplicate',
        QuickAdd: 'Quick add'
    },
    systemImport: {
        MisaService: 'MISA SME.NET - Services',
        MisaMerchandise: 'MISA SME.NET - Commodities',
        SME2012Service: 'MISA SME.NET 2012 - Services',
        SME2012PayMerchandise: 'MISA SME.NET 2012 - Commodities (Pay immediately)',
        SME2012NotPayMerchandise: 'MISA SME.NET 2012 - Commodities (Unpaid)',
        FastService: 'FAST - Service',
        FastMerchandise: 'FAST - Goods'
    },
    DeclarationExportAccounting: {
        MisaSmeMerchandise: 'MISA SME.NET - Commodities'
    },
    newInvoiceExport: {
        InvoiceServiceMOKA: 'MOKA - Service purchase invoice',
        InvoiceSaleMOKA: 'MOKA - Invoice for domestic purchase',
        InvoiceMOKA: 'MOKA - Cash disbursement'
    },
    invoicesMassan: {
        InvoiceMassan: 'MASAN - Summary table of input purchasing goods and services'
    },
    outInvoiceExport: {
        InvoiceSaleAmis: 'MISA AMIS Accounting - Goods',
        ServiceAmis: 'MISA AMIS Accounting - Service',
        InvoiceListAmis: 'MISA AMIS Accounting - List of invoice',
        SMEInvoiceSale: 'MISA SME - Sales invoice',
        SMESale: 'MISA SME - Sales'
    },
    lstImportVal: {
        InputInvoice: 'List of input invoice'
    },
    lstImportOutInvoiceVal: {
        OutInvoiceList: 'List of output invoice'
    },
    lstInvoiceStatement: {
        ListInvoiceBuyer: 'Input invoice list of goods and services purchased (summary)',
        InvoiceBuyer: 'Input invoice list of goods and services purchased (details)'
    },
    DeclarationExport: {
        DeclarationList: 'Customs declaration list',
        DeclarationDetail: 'Customs declaration detail'
    },
    InvoiceReportList: {
        ListInvoiceBuyer802021: 'Purchase statement according to form No. 01-1/HT (Circular No. 80/2021/TT-BTC)'
    },
    listImport: {
        InvoiceList: 'List of input invoice',
        ExportToOtherApp: 'Import into accounting software'
    },
    PaymentMethod: {
        Admin: 'Admin',
        User: 'User  ',
        ATM: 'ATM card',
        Visa: 'Credit card',
        PaymentProvider: 'E-wallet',
        Tranfers: 'Bank transfer',
        Paypal: 'PayPal',
        Jetpay: 'Jetpay'
    },
    PaymentStatus: {
        New: 'Unpaid',
        WaitPaymentConfirm: 'Wating for payment confirmation',
        SentPaymentConfirm: 'Sent payment confirmation',
        Paid: 'Paid',
        CancelPayment: 'Order was canceled'
    },
    FileType: { All: 'All', Xml: 'XML', Pdf: 'PDF', Image: 'Image' },
    InvoiceTemplate: { TaxRate: 'A tax rate', ManyTaxRate: 'Multiple tax rates' },
    VatRate: {
        KHAC: 'KHAC',
        KKKNT: 'KKKNT',
        KCT: 'KCT',
        KTPVDC: 'KTPVDC',
        KTGTT: 'KTGTT',
        Rate0: '0',
        Rate5: '5%',
        Rate8: '8%',
        Rate10: '10%'
    },
    AuditingLogActionType: {
        None: 'Unknown invoice',
        Upload: 'Upload invoice',
        DeleteInvoice: 'Delete invoice',
        RestoreInvoice: 'Restore deleted invoice',
        InvoiceAccept: 'Accept name/address/tax code',
        UpdateSupplierCode: 'Update supplier/customer',
        InvoiceStick: 'Labeling',
        InvoiceAttachFile: 'Add file attachment',
        InvoiceDescription: 'Note',
        UpdateCompany: 'Edit organizational structure',
        DeleteEmail: 'Delete email',
        RestoreEmail: 'Restore email',
        DeleteForeverEmail: 'Delete permanently',
        InvoiceAttachFileRemove: 'Delete this attachment',
        AddCompany: 'Add organizational structure',
        DeleteCompany: 'Delete organizational structure',
        DeleteInvoiceStick: 'Delete label ',
        Accounted: 'Mark as accounted',
        UnAccounted: 'Mark as unaccounted',
        ReUploadInvoicePdf: 'Update PDF file invoice',
        ReUploadInvoiceImg: 'Update image file invoice',
        UpdateRoleUser: 'Edit user',
        MoveInvoice: 'Transfer input invoice ',
        AcceptSellerSignature: "Accept valid supplier's digital signature",
        AcceptSellerActiveStatus: "Accept valid seller's activity status",
        AcceptTaxRiskStatus: "Accept valid seller's tax risk",
        ConnectInvoiceLogin: 'Connect to get invoice from supplier automatically',
        ConnectInvoiceLogout: 'Disconnect to get invoice from supplier automatically',
        EditHandEntered: 'Edit hand input invoice',
        ConnectTaxaxionLogin: 'Set up connecting to Tax Authority account automatically',
        ConnectTaxaxionLogout: 'Disconnect to Tax Authority data',
        ConnectInvoiceSync: 'Synchronize supplier connection data',
        ConnectTaxaxionSync: 'Synchronize Tax Authority data',
        CheckingVat: 'Check the tax rate',
        CheckAgainEmail: 'Recheck email',
        RefreshInvoiceTaxaxion: 'Reload Tax Authority data',
        SettingSystemDownload: 'Set the download file name',
        SettingSystemPayment: 'Set up payment term reminders',
        PaymentInvoice: 'Mark as paid',
        AcceptPayment: 'Mark as paid',
        InvoiceSticks: 'Batch labeling',
        RemoveStick: 'Remove label',
        RemoveAndAttachStick: 'Labeling/remove label',
        InsertDeleteStick: 'Add label/remove label',
        UpdateStick: 'Edit label',
        HandEntered: 'Check the hand input invoice',
        SaveDraft: 'Save draft',
        AddUser: 'Add user',
        DeleteUser: 'Delete user',
        AddJobTitle: 'Add a title',
        AddRolePermission: 'Add roles and permissions',
        DeleteRolePermission: 'Delete roles and permissions',
        EditRolePermission: 'Edit roles and permissions',
        DeleteOutInvoice: 'Delete output invoice',
        RestoreOutInvoice: 'Restore output invoice',
        MoveOutInvoice: 'Transfer output invoice ',
        ConnectDownloadMeInvoice: 'Set up to download MISA meInvoice output invoices automatically ',
        UnConnectDownloadMeInvoice: 'Unset to download MISA meInvoice output invoices automatically ',
        ConnectAgainTaxaxion: 'Reconnect to account',
        UnConnectTaxaxion: 'Disconnect',
        ConnectTaxaxionInvoice: 'Connect Tax Authority account',
        AcceptExistTCT: 'Accept invoice exists validly on Tax Authority system',
        CheckAgianV2: 'Recheck invoice',
        DeclarationCheckAgain: 'Recheck customs declaration',
        UnRead: 'Mark as unread email',
        RemoveSticks: 'Remove label',
        AttachStick: 'Labeling',
        SettingTransformOrg: 'Set up to transfer invoice for branches/departments automatically',
        InsertTransformOrg: 'Add the set up to transfer invoice for branches/departments automatically',
        EditTransformOrg: 'Edit the set up to transfer invoice for branches/departments automatically',
        DeleteTransformOrg: 'Delete invoice auto transfer settings for branch/department',
        InsertSupplier: 'Add new supplier',
        CheckAgainMultiEmail: 'Recheck email',
        SettingNoDownloadInvoice: 'Change invoice download settings by supplier',
        UnSettingTransformOrg: 'Unset transfer of invoices to branches/departments automatically',
        InsertSupNoDownInv: 'Add setting to skip some suppliers when downloading invoices for branches/departments',
        DeleteSupNoDownInv: 'Delete setting to skip some suppliers when downloading invoices for branches/departments',
        InsertSupOnlyDownInv: 'Add settings to only download invoices from selected suppliers for branches/departments',
        ChooseSupplierOnlyOrSupplierNoDownloadInv: 'Change invoice download settings by supplier',
        DeleteSupOnlyDownInv: 'Delete settings to only download invoices from selected suppliers for branches/departments',
        AcceptTaxaxionSignature: "Tax Authority's e-signature is accepted validly",
        RefreshInvoice: 'Reload supplier data',
        UploadOutInvoice: 'Upload output invoice',
        SettingTransferInvByTaxCode: 'Set up to transfer invoice from email source',
        UnSettingTransferInvByTaxCode: 'Unset transfer invoice from email source',
        AddTransferInvByTaxCode: 'Add the set up to transfer invoice from email source',
        UpdateTransferInvByTaxCode: 'Edit the set up to transfer invoice from email source',
        DeleteTransferInvByTaxCode: 'Delete the set up to transfer invoice from email source',
        DownloadInvoiceWithoutCode: 'Set up to download the invoices without tax code sent in the form of a summary table automatically',
        DownloadOutInvoiceWithoutCode: 'Set up to download the invoices without tax code sent in the form of a summary table automatically',
        UnDownloadInvoiceWithoutCode: 'Unset to download the invoices without tax code sent in the form of a summary table automatically',
        UnDownloadOutInvoiceWithoutCode: 'Unset to download the invoices without tax code sent in the form of a summary table automatically',
        ConnectAgainSupplier: 'Reconnect to account',
        UploadFileXML: 'Update XML file invoice',
        SelectOtherDownloadInvoiceInbot: 'Set input invoice type to be downloaded from the tax authority',
        UnSelectOtherDownloadInvoiceInbot: 'Unset the input invoice type to be downloaded from the tax authority',
        SelectOtherDownloadInvoiceOutInbot: 'Set the output invoice type to be downloaded from the tax authority',
        UnSelectOtherDownloadInvoiceOutInbot: 'Unset the output invoice type to be downloaded from the tax authority',
        SettingTypeDownloadInvoiceInbot: 'Set the input invoice type downloaded from the tax authority',
        SettingTypeDownloadInvoiceOutbot: 'Set the output invoice type downloaded from the tax authority',
        AcceptCheckTax: 'Accept tax rates according to the Tax Reduction Resolution',
        UnPaymentInvoice: 'Uncheck payment',
        SettingSystemIgnoreExistTax: 'The list of invoice numbers, serial not accepted exists on the Tax Authority',
        SettingSystemCriteriaVerification: 'Set up check criteria on invoices',
        SettingAbbreviationSetup: 'Set up abbreviation check settings for buyer/seller name and address',
        ActionSupplierAcceptTaxAuthority: 'Set do not check existence on Tax Authority',
        ActionEmailReceiveAlert: 'Set up email alerts when a customer/researcher changes their operating status',
        SettingActionEmailReceiveAlert: 'Set up email alerts when a customer/researcher changes their operating status',
        RemovePdf: 'Remove instance',
        SettingRemind: 'Setting Remind',
        TaxaxionSyncByTool: 'Synchronize tax authority data using tools',
        UpdatePdfInvoice: 'Supplement to the invoice instance',
        UpdatePdfFromEmail: 'Supplement to the invoice instance',
        UpdatePdfFromSearch: 'Update invoice instance',
        AutoDownloadPdf: 'Supplement to the invoice instance',
        AutoDownloadXml: 'Xml to the invoice instance',
        SettingTemplate: 'Set up invoice templates',
        UploadFilePdf: 'Download the invoice version',
        UploadDeclaration: 'Upload declaration',
        /// <summary>
        /// Chấp nhận đơn vị tính
        /// </summary>
        AcceptedUnitName: 'Accept valid unit of measurement',
        /// <summary>
        /// Chấp nhận số lượng
        /// </summary>
        AcceptedQuantity: 'Accept valid quantity information',
        /// <summary>
        /// Chấp nhận đơn giá
        /// </summary>
        AcceptedUnitPrice: 'Accept valid unit price information',
        /// <summary>
        /// Xóa thông tin HHDV trong lịch sử chấp nhận thuế suất
        /// </summary>
        DeleteItemVatRate: 'Delete goods and services',
        /// <summary>
        /// Sửa thông tin lịch sử chấp nhận thuế suất
        /// </summary>
        EditHistoryVatRate: 'Edit acceptance of goods and services tax rates',
        SpamEmail: 'Report email spam',
        NotSpamEmail: 'Mark emails as not spam',
        UserSetup: 'User settings',
        ClassificationCost: 'Invoice categorization',
        ClassificationCostMany: 'Batch invoice categorization',
        SettingClassificationInvoice: 'Set up automatic invoice classification',
        SettingCostNorms: 'Set cost norms',
        AcceptExchangeRate: 'Accept valid exchange rate information',
        SyntheticVatRate: 'Accept valid information summarized by tax rate',
        SettingCostType: 'Set up cost rate',
        UpdateInvoiceCostType: 'Update cost norms',
        UpdateInvoiceCostTypeMany: 'Update bulk cost norms',
        DeleteDeclaration: 'Delete declaration',
        RestoreDeclaration: 'Restore declaration',
        MoveOnDeclaration: 'Transfer declaration',
        RestoreInvoices: 'Restore bulk invoices',
        RestoreOutInvoices: 'Restore bulk output invoices',
        AcceptMultiResult: 'Accept valid results',
        UpdateInvoiceEmailReceive: 'Update email address to receive invoices',
        UpdateFilterInvoiceList: 'Default date filter settings on the incoming invoice list',
        SaveCriteriaSetup: 'Save criteria setup invoice',
        SaveAbbreviationSetup: 'Abbreviation check settings for buyer/seller name and address',
        CharacteristicGoods: 'Accept featured goods',
        AcceptCheckLogic: 'Accept accuracy in data calculation',
        CompareTotalAmountInWordsAndNumbers: 'Accept difference between total amount in words and total amount in numbers',
        ChangeIdentificationNumberOrganizationChange: 'Automatically remove invoice auto-transfer settings from email source',
        /// Bỏ Chấp nhận tên địa chỉ hóa dơn
        InvoiceUnAccept: 'Unaccept name/address/tax code',
        AcceptInvoiceName: 'Accept invoice name',
        UnacceptInvoiceName: 'Unaccept invoice name',
        SettingAmountBeforeDiscountSetup: 'Set up formula for calculating amount before discount',
        AcceptBusinessLocation: 'Accept Incorrect business location information',
        DeleteDeclarationBatch: 'Batch delete customs declarations',
        CheckAgainOutInvoice: 'Recheck the output invoice',
        SettingShowInvoiceLoadingList: 'Change display setting of invoices downloading list',
        ReloadPendingInvoice: 'Reload pending invoice',
        ReloadPendingOutInvoice: 'Reload pending output invoice'
    },
    KindAccountingDate: {
        All: 'All',
        Accounted: 'Mark as accounted',
        NotAccounted: 'Unaccounted'
    },
    StatusView: {
        All: 'All',
        Viewed: 'Viewed',
        UnViewed: 'Unviewed'
    },
    AttachStatus: {
        All: 'All',
        HasAttachFile: 'Has attachment',
        NotHasAttachFile: 'No attachment'
    },
    InvoiceEmailStatus: {
        All: 'All',
        InvoiceValid: 'Valid invoice',
        EmailInvalid: 'Invalid email',
        InvoiceInvalid: 'Invalid invoice',
        MaxAttachmentSize: 'Email size exceeds 10MB',
        InvoiceDuplicate: 'Duplicate invoice',
        InvoiceNoRead: 'Unable to process invoice',
        Draft: 'Draft',
        Checking: 'Checking',
        Expired: 'Expired ',
        InvoiceDetele: 'Deleted invoice',
        InvoiceNotNeedCheck: 'Foreign supplier invoice'
    },
    TypeInvoiceReceive: {
        All: 'All',
        Upload: 'Upload',
        Email: 'Email',
        Auto: 'Auto download',
        HandInput: 'Hand input'
    },
    DateFilterType: {
        InvoiceDate: 'Invoice',
        AccountingDate: 'Accounting',
        ReceivedDate: 'System entry',
        PaymentWarning: 'Payment due reminder',
        PaymentOutOfDate: 'Payment due',
        PaymentNotPay: 'Unpaid invoice',
        ChangeStatusInvoiceDate: 'Change of status on Tax Authority',
        ChangeStatusInvoiceOnSystemDate: 'Invoice status change on Inbot',
        DeclarationDate: 'Declaration Date'
    },
    ReasonType: {
        ProductNotGood: 'The product does not meet the demand',
        ProductError: 'The product is often defective',
        SupportServiceNotGood: 'Customer support consulting service is poor',
        HighPrice: 'Price is high',
        UseConvenient: 'The operation is not convenient',
        SlowProcessingSpeed: 'Processing speed is slow',
        SecurityNotGood: 'Software security is poor',
        ReasonOther: 'Other reason'
    },
    TThaiHDonEnum: {
        Goc: 'New invoice',
        ThayThe: 'Replacement invoice',
        DieuChinh: 'Adjustment invoice',
        DaThayThe: 'Replaced invoice',
        DaDieuChinh: 'Adjusted invoice  ',
        Xoa: 'Cancelled invoice',
        Unknown: 'Unknown invoice'
    },
    AmountPayment: {
        Nothing: '',
        NotPair: 'Unpaid',
        PairAll: 'Full payment',
        PairOutOfDate: 'Overdue payment',
        PairWarning: 'Maturity',
        PairPart: 'Partial payment'
    },
    ReadEmailStatus: { All: 'All', NotRead: 'Unread', Read: 'Read' },
    FileTypeDownloadInvoice: { All: 'All', Pdf: 'Viewer', Xml: 'XML', Attachment: 'Attachments Only', PdfAndXml: 'PDF and XML' },
    ActiveStatus: {
        All: 'All',
        Active: 'Active',
        Inactive: 'Inactive',
        WaitingUpdateIdentityCode: 'Waiting for identification',
        WaitingVerification: 'Waiting for verification',
        NotSure: 'Unknown invoice'
    },
    ReportInvoiceStatus: {
        All: 'All',
        Adjust: 'Adjustment',
        Replace: 'Replacement'
    },
    ConntectTaxaxionStatus: {
        Today: 'Today',
        ThisWeek: 'This week',
        SevenDay: '7 days',
        Last30Day: 'Last 30 days'
    },
    StatusStick: {
        All: 'All',
        InvoiceOriginal: 'New invoice',
        InvoiceReplace: 'Replacement invoice',
        InvoiceAdjust: 'Adjustment invoice',
        InvoiceReplaced: 'Replaced invoice',
        InvoiceAdjusted: 'Adjusted invoice',
        InvoiceCancel: 'Cancelled invoice',
        InvoiceUnknow: 'Unknown invoice'
    },

    StatusStickReport: {
        All: 'All',
        InvoiceOriginal: 'New invoice',
        InvoiceReplace: 'Replacement invoice',
        InvoiceAdjust: 'Adjustment invoice',
        InvoiceReplaced: 'Replaced invoice',
        InvoiceAdjusted: 'Adjusted invoice',
        InvoiceUnknow: 'Unknown invoice'
    },

    FilterOperator: {
        Contains: 'Contains',
        NotContains: 'NotContains',
        Equals: 'Equals',
        NotEquals: 'NotEquals',
        StartWith: 'StartsWith',
        EndWith: 'EndsWith',
        LessThan: 'LessThan', //Nhỏ hơn
        LessThanOrEqual: 'LessThanOrEqual', //Nhỏ hơn hoặc bằng
        GreaterThan: 'GreaterThan', //Lớn hơn
        GreaterThanOrEqual: 'GreaterThanOrEqual', //Lớn hơn hoặc bằng
        In: 'In', //Trong
        NotIn: 'NotIn', //Không trong
        Between: 'Between', //Giữa khoảng
        Blank: '(Blank)',
        NotBlank: '(Not Blank)',
        IsNull: 'Is Null',
        IsNotNull: 'Not Null'
    },
    RiskStatusCombobox: {
        All: 'All',
        NoRisky: 'No Risk',
        Risky: 'Risk'
    },
    FilterMCQT: {
        All: 'All',
        IsNull: 'Empty',
        NotNull: 'Non Empty'
    },
    /**
     * Enum filter header dựa trên enum InvoiceStatus
     */
    InvoiceStatusFilter: {
        All: 'All',
        WaitChecking: 'Wait Checking',
        Valid: 'Valid',
        Invalid: 'Invalid',
        NotNeedCheck: 'Not Check',
        InvalidBuyerInfo: "Incorrect buyer's information",
        InvalidSellerInfo: "Incorrect seller's information",
        InvalidGeneralInfo: 'Incorrect general information',
        InvalidItems: 'Incorrect inventory items',
        InvalidPaymentInfo: 'Incorrect payment information',
        InvalidSignInfo: 'Incorrect signature information',
        CheckWidthTCT: 'Check with Tax authority',
        InvalidInvoiceInstead: 'Invalid Instead Invoice',
        InvalidInvoiceAdjust: 'Invalid Adjust Invoice'
    },
    /**
     * Bộ lọc tệp hóa đơn
     */
    InvoiceFileFilter: {
        All: 'All',
        NoPdf: 'No pdf',
        HasPdf: 'Has pdf',
        NoXml: 'No XML',
        HasXml: 'Has XML',
        HasXmlNoPdf: 'Has XML - No pdf',
        HasPdfNoXml: 'Has XML - No xml',
        HasXmlHasPdf: 'Has XML - Has pdf'
    },
    InvoiceHasPdfFilter: {
        All: 'All',
        NoPdf: 'No PDF',
        HasPdf: 'Has PDF',
        HasXmlNoPdf: 'Has PDF - No XML',
        HasPdfNoXml: 'Has PDF - No XML',
        HasXmlHasPdf: 'Has PDF - Has XML'
    },
    InvoiceHasXmlFilter: {
        All: 'All',
        NoXml: 'No XML',
        HasXml: 'Has XML',
        HasXmlNoPdf: 'Has XML - No PDF',
        HasPdfNoXml: 'No XML - Has PDF',
        HasXmlHasPdf: 'Has XML - Has PDF'
    },
    /**
     * Enum thể hiện trạng thái kiểm tra thuế suất gán vào combobox
     */
    CheckingVatStatusFlagsFilter: {
        All: 'All',
        None: 'None',
        Exact: 'Exact tax rate',
        UnExact: 'UnExact tax rate',
        Checking: 'Checking',
        ErrorCheckingVat: 'Discount tax rate error',
        Accept: 'Tax rate are accepted'
    },
    AmountPaymentFilter: {
        All: 'All',
        Nothing: 'Nothing',
        NotPair: 'Unpaid',
        PairAll: 'Full payment',
        PairOutOfDate: 'Overdue payment',
        PairWarning: 'Maturity',
        PairPart: 'Partial payment'
    },

    CostTypeEnumGrid: {
        //Tất cả
        All: 'All',
        /// <summary>
        /// Điện
        /// </summary>
        Electricity: 'Electricity',
        /// <summary>
        /// Nước
        /// </summary>
        Water: 'Water',
        /// <summary>
        /// Viễn thông
        /// </summary>
        Telecommunication: 'Telecommunication',
        /// <summary>
        /// Bưu phí
        /// </summary>
        Postage: 'Postage',
        /// <summary>
        /// Chi phí tài chính
        /// </summary>
        FinancialExpenses: 'FinancialExpenses',
        /// <summary>
        /// Đường bộ
        /// </summary>
        RoadFees: 'RoadFees',
        /// <summary>
        /// Bảo hiểm
        /// </summary>
        Insurance: 'Insurance',
        /// <summary>
        /// Thuê mặt bằng
        /// </summary>
        Rent: 'Rent',
        /// <summary>
        /// Xăng, dầu
        /// </summary>
        Petroleum: 'Petroleum',
        /// <summary>
        /// Tiếp khách
        /// </summary>
        ReceivingGuests: 'Receiving guests',
        /// <summary>
        /// Lưu trú
        /// </summary>
        Accommodation: 'Accommodation',
        /// <summary>
        /// Tiếp thị, quảng cáo
        /// </summary>
        MarketingOrAdvertising: 'Marketing, advertising',
        /// <summary>
        /// Phí gửi xe
        /// </summary>
        ParkingFee: 'Parking fee',
        //Không phân loại
        None: 'Uncategorized'
    },

    CostTypeEnumFilter: {
        All: 'All',
        Electricity: 'Electricity',
        Water: 'Water',
        Telecommunication: 'Telecommunication',
        Postage: 'Postage',
        FinancialExpenses: 'Financial Expenses',
        RoadFees: 'Road Fees',
        Insurance: 'Insurance',
        Rent: 'Rent',
        Petroleum: 'Petroleum',
        ReceivingGuests: 'Receiving guests',
        Accommodation: 'Accommodation',
        MarketingOrAdvertising: 'Marketing, advertising',
        ParkingFee: 'Parking fee'
    },

    YesNo: {
        All: 'All',
        Yes: 'Yes',
        No: 'No',
        Blank: 'Blank'
    },
    StatusDownloadInvoice: {
        All: 'All',
        TotalInvoiceifference: 'Not loaded yet', // chưa tải được hóa đơn
        TotalDownloadSuccess: 'Download successful', // tải thành công
        TotalDownloadFail: 'Download failed', // tải thất bại
        TotalInvoiceProcessing: 'Downloading', // đang tải
        TotalInvoiceIgnore: 'Invoice Ignored', // bỏ qua
        TotalInvoiceSuccess: 'Invoice processed', // hóa đơn đang xử lý
        TotalInvoiceDuplicate: 'Invoice duplicated' // hóa đơn trùng
    },
    DatePickerTypeSelect: {
        Month: 'Month',
        Quarter: 'Quarter',
        Year: 'Year'
    },
    CompareType: {
        /// <summary>
        /// Previous period
        /// </summary>
        /// <example>
        /// Q3/2025 → Q2/2025
        /// Q1/2025 → Q4/2024
        /// </example>
        Previous: 'Previous period',

        /// <summary>
        /// Same period last year
        /// </summary>
        /// <example>
        /// Q3/2025 → Q3/2024
        /// Q1/2025 → Q1/2024
        /// </example>
        SameLastYear: 'Same period last year'
    },
    TypeInvoiceReport: {
        All: 'All types of invoices',
        OnlyVatInvoice: 'VAT invoice only'
    }
};